/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ProgressCurvePoint } from './progressCurvePoint';
import type { CohortInsights } from './cohortInsights';

export interface ProgressCurveAnalysis {
  /** Historical average progress curve */
  historicalBenchmark?: ProgressCurvePoint[];
  /** Current cohort progress curve */
  currentCohortCurve?: ProgressCurvePoint[];
  insights: CohortInsights;
  /** Number of historical submissions used for benchmark */
  benchmarkSampleSize: number;
}
